import { Component } from "preact";
import clsx from "clsx";

import style from "./index.scss";

import Browser from "../Browser";

import connstants from "../../const";

const MODES = ["left", "right", "top", "bottom", "spanning"];

export default class Device extends Component {
  componentDidMount() {
    this._setWrapperDimensions();
    this.adjustDeviceZoom(this.props.deviceType, this.props.orientation);

    //TODO: debounce
    window.addEventListener("resize", () => {
      this._setWrapperDimensions();
      this.adjustDeviceZoom(this.props.deviceType, this.props.orientation);
    });
  }

  _setWrapperDimensions() {
    this.wrapperDimensions.height = window.innerHeight - 110; //TODO: do somethinng bout this nice hardcoded padding
    this.wrapperDimensions.width = window.innerWidth - 60;
  }

  wrapperDimensions = {
    width: 0,
    height: 0
  };

  adjustDeviceZoom = (deviceType, orientation) => {
    let wrapperHeight = this.wrapperDimensions.height;
    let wrapperWidth = this.wrapperDimensions.width;

    let deviceHeight = connstants[deviceType][orientation].height;
    let deviceWidth = connstants[deviceType][orientation].width;

    let smallestScaleFactor = 1;

    if (deviceHeight > wrapperHeight) {
      smallestScaleFactor = wrapperHeight / deviceHeight;
    }

    if (deviceWidth > wrapperWidth) {
      let tmp = wrapperWidth / deviceWidth;
      smallestScaleFactor =
        tmp < smallestScaleFactor ? tmp : smallestScaleFactor;
    }

    // round to the closest 5
    this.props.updateDeviceSettings({
      deviceZoom: smallestScaleFactor.toFixed(2)
    });
  };

  componentWillReceiveProps = updatedProps => {
    if (this.props.deviceType !== updatedProps.deviceType) {
      this.adjustDeviceZoom(updatedProps.deviceType, updatedProps.orientation);
    }

    if (this.props.orientation !== updatedProps.orientation) {
      this.adjustDeviceZoom(updatedProps.deviceType, updatedProps.orientation);
    }
  };

  render(props) {
    return (
      <main class={style.deviceWrapper}>
        <div
          class={clsx(
            style.device,
            style[props.deviceType],
            style[props.orientation]
          )}
          style={`transform: scale(${props.deviceZoom})`}
        >
          <div class={clsx(style.screen, style.start, style.steel)}></div>
          <div class={clsx(style.screen, style.end, style.steel)}></div>
          {props.deviceType === "neo" && (
            <div>
              <div class={clsx(style.screen, style.bezel, style.start)}></div>
              <div class={clsx(style.screen, style.bezel, style.end)}></div>
            </div>
          )}
          <div class={style.systemStart}></div>
          <div
            class={clsx(
              style.browserOuterWrapper,
              style[MODES[props.windowMode]]
            )}
          >
            <div class={style.browserInnerWrapper}>
              <Browser
                url={props.url}
                orientation={props.orientation}
                deviceType={props.deviceType}
                windowMode={props.windowMode}
                updateDeviceSettings={props.updateDeviceSettings}
              />
            </div>
          </div>

          <div class={style.systemEnd}></div>

          {props.deviceType === "neo" && (
            <div>
              <div class={style.hinge}></div>
              <div class={style.hingeBezel}>
                <hr />
              </div>
            </div>
          )}

          {props.deviceType === "duo" && (
            <div>
              <div class={clsx(style.screen, style.bezel, style.start)}></div>
              <div class={style.hinge}></div>
              <div class={clsx(style.screen, style.bezel, style.end)}></div>
            </div>
          )}
        </div>
      </main>
    );
  }
}
